import React from 'react';
import { Link } from 'react-router-dom';
import { FormGroup, FormControl, FormLabel, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ChangePassword = ({
  password = '',
  repeatPassword = '',
  handleSubmitPassword,
  handlePasswordChange,
  handlePasswordRepeatChange,
  includeResetLink = false,
}) => {
  return (
    <form onSubmit={handleSubmitPassword}>
      <FormGroup>
        <FormLabel>Password</FormLabel>
        <FormControl
          type="password"
          id="password"
          value={password}
          onChange={handlePasswordChange}
          autoComplete="new-password"
          className="mb-2"
        />
        <FormControl.Feedback />

        <FormLabel>Repeat Password</FormLabel>
        <FormControl
          type="password"
          id="repeatPassword"
          value={repeatPassword}
          onChange={handlePasswordRepeatChange}
          autoComplete="new-password"
          className="mb-2"
        />
        <FormControl.Feedback />
      </FormGroup>
      <div className="login-controls">
        <Button variant="primary" type="submit" block onClick={handleSubmitPassword}>
          Change Password
        </Button>
      </div>
      {includeResetLink === true && (
        <div className="goback">
          <Link to="/forgotpassword">Request a new password reset link</Link>
        </div>
      )}
    </form>
  );
};

ChangePassword.defaultProps = {
  password: '',
  repeatPassword: '',
};

ChangePassword.propTypes = {
  password: PropTypes.string,
  repeatPassword: PropTypes.string,
  handleSubmitPassword: PropTypes.func,
  handlePasswordChange: PropTypes.func,
  handlePasswordRepeatChange: PropTypes.func,
  includeResetLink: PropTypes.bool,
};

export default ChangePassword;
